export default (part) => (`${'mai'}${'lto'}${':'}${part[0]}${String.fromCharCode(2 ** 6)}${part[1]}.${part[2]}`)
